import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import "./aicall.css";
function createMarkup(html) {
    return { __html: html };
}

const CUSTOMER_STATUS = ['Customer Contacted', 'Customer Cancelled', 'Customer Serviced'];

const capitalizeFirst = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : "N/A";

// Safely parse JSON-like inputs that might already be objects, malformed, or double-encoded
const safeParseJson = (input, fallback = {}) => {
    if (input == null) return fallback;
    if (typeof input === 'object') return input;
    if (typeof input !== 'string') return fallback;
    try {
        const first = JSON.parse(input);
        if (first && typeof first === 'object') return first;
        if (typeof first === 'string') {
            try {
                const second = JSON.parse(first);
                if (second && typeof second === 'object') return second;
            } catch (e2) {
                // ignore
            }
        }
    } catch (e1) {
        try {
            const repaired = input.replace(/\\"/g, '"');
            const repairedParsed = JSON.parse(repaired);
            if (repairedParsed && typeof repairedParsed === 'object') return repairedParsed;
        } catch (e3) {
            // ignore
        }
    }
    return fallback;
};

export const DatatableRow = props => {
    let parseData = props?.list?.custom_capture ? props?.list?.custom_capture : {};
    // let parseData_arr=typeof parseData === 'string'? JSON.parse(parseData) : parseData;
    let parseData_arr = safeParseJson(parseData, {});
    let callOutcome=typeof parseData_arr['Call outcome']!=='undefined'? parseData_arr['Call outcome']:'N/A';
    const isSmsRow = props.call_type === 'sms';
    const naCell = <span style={{ color: "#999" }}>N/A</span>;
    const hippaBlocked = props.list.hippaOn == "block";
    const rowId = props.list.auto_id ?? props.list.id;
    const viewDetailsId = props.list.view_details?.id ?? rowId;
    const viewDetailsLabel = props.list.view_details?.label || "View Details";

    return (
    <Table.Row className={`table-row-ai tr__${rowId}`}>
        <Table.Cell>

            <label className="kt-checkbox kt-checkbox--single"><input type="checkbox" checked={props.list.checked ? true : false} auto_id={rowId} onChange={() => props.channgeEvent(rowId)}></input>&nbsp;<span></span></label>

        </Table.Cell>
        <Table.Cell style={{ whiteSpace: "nowrap", width: "200px" }}>
            <div style={{ width: 170 }}>{props.list.created_at}</div>
        </Table.Cell>
        <Table.Cell>
            <div style={{ width: 35 }}>{props.list.call_from ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{props.list.call_from}</span></span> : ''}
            </div>
        </Table.Cell>
        {isSmsRow && (
        <Table.Cell>
            <div style={{ width: 100 }}>{props.list.forwarded ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{props.list.forwarded ? props.list.forwarded : 'N/A'}</span></span> : ''}
            </div>
        </Table.Cell>
        )}
        <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
            <div style={{ display: "contents", width: 50 }}>{(props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);"></a></span> : <a className="cursorpointer des-link" onClick={(e) => props.viewDetails(viewDetailsId, e)}>{viewDetailsLabel}</a>}
            </div>
        </Table.Cell>
        {!isSmsRow && (
        <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
            <div style={{ display: "contents", width: 50 }}>
                {hippaBlocked ? (
                    <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);"></a></span>
                ) : !props.list.call_recording ? (
                    naCell
                ) : (
                    <a className="cursorpointer des-link" onClick={() => props.viewRecording(props.list.call_recording, rowId, props.list.call_recording_view)} style={{display: 'flex', alignItems: 'center', columnGap: 8}}><span>Listen</span> <i className='fa fa-volume-up'></i></a>
                )}
            </div>
        </Table.Cell>
        )}
        <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
            <div style={{ display: "contents", width: 50 }}>{(props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);"></a></span> : <a className="cursorpointer des-link" onClick={() => props.viewSummary(rowId)}>View Details</a>}
            </div>
        </Table.Cell>

        {isSmsRow ? (
            <>
                <Table.Cell style={{ width: "150px" }}>
                    {props.list.status_label || props.list.message_status || props.list.status || ""}
                </Table.Cell>
                <Table.Cell id={"ai_chatstatus_" + rowId} style={{ width: "150px" }}>
                    {props.list.transcript_status
                        ? (props.list.hippaOn == "block")
                            ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span>
                            : props.list.transcript_status
                        : ""}
                </Table.Cell>
            </>
        ) : (
            <Table.Cell id={"ai_chatstatus_" + rowId} style={{width: "150px"}}>{props.list.chat_status?(props.list.hippaOn =="block")?<span><a onClick={()=>props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span>:props.list.chat_status:""}</Table.Cell>
        )}

        <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
            <div style={{ display: "contents", width: 50 }}>
                {hippaBlocked ? (
                    <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);"></a></span>
                ) : (
                    <a className="cursorpointer des-link" onClick={() => props.viewNoteshtml(rowId)}>View Notes</a>
                )}
            </div>
        </Table.Cell>
		
		
    
		{!isSmsRow && (
		<Table.Cell>
			<div style={{ width: 100 }}>{props.list.forwarded ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{props.list.forwarded ? props.list.forwarded : 'N/A'}</span></span> : ''}
			</div>
		</Table.Cell>
		)}
		<Table.Cell>
			<div style={{ width: 100 }}>{props.list.ai_call_duration ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{props.list.ai_call_duration}</span></span> : ''}
			</div>
		</Table.Cell>
		
		
		{!isSmsRow && (
		<Table.Cell>
			<div style={{ width: 100 }}>{props.list.call_abandoned ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{props.list.call_abandoned}</span></span> : ''}
			</div>
		</Table.Cell>
		)}
		
		{/* {typeof props.user_id!='undefined' && props.user_id==721 && <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "210px" }}>
		<div style={{ width: 150,whiteSpace:'normal' }}>{typeof callOutcome!='undefined' ? (props.list.hippaOn == "block") ? <span><a onClick={() => props.openHipaaRow(props.list.auto_id)} href="javascript:void(0);">Hidden</a></span> : <span ><span>{callOutcome}</span></span> : ''}
		</div>
			
		</Table.Cell>} */}
		<Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
			<div style={{ display: "contents", width: 50 }}>
                {hippaBlocked ? (
                    <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span>
                ) : (
                    <span style={{display: 'flex', flexDirection: 'column', rowGap: 8}}>
                        <a className="cursorpointer kt-badge  kt-badge--info kt-badge--inline kt-badge--pill" style={{color: 'white', fontWeight: 500}} onClick={() => props.viewPaerseData(parseData, rowId)}>View Parsed Data</a>
                    </span>
                )}
			</div>
		</Table.Cell>
		<Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
			<div style={{ display: "contents", width: 50 }}>
                {hippaBlocked ? (
                    <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span>
                ) : (
                    <span style={{display: 'flex', flexDirection: 'column', rowGap: 8}}>
                        <a className="cursorpointer kt-badge  kt-badge--info kt-badge--inline kt-badge--pill" style={{color: 'white', fontWeight: 500}} onClick={() => props.notificationDetails(rowId)}>View Details </a>
                    </span>
                )}
			</div>
        </Table.Cell>
        <Table.Cell className="cWidth" style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>
            <div style={{ display: "contents", width: 50 }}>
                {hippaBlocked ? (
                    <span><a onClick={() => props.openHipaaRow(rowId)} href="javascript:void(0);">Hidden</a></span>
                ) : isSmsRow && props.list.log_id && typeof props.viewWebhookData === "function" ? (
                    <a
                        className="cursorpointer des-link"
                        onClick={() => props.viewWebhookData(rowId, props.list.id)}
                    >
                        View
                    </a>
                ) : props.list.log_id && typeof props.viewWebhookData === "function" ? (
                    <a
                        className="cursorpointer des-link"
                        onClick={() => props.viewWebhookData(rowId, props.list.log_id)}
                    >
                        View
                    </a>
                ) : (
                    <span style={{ color: "#999" }}>—</span>
                )}
            </div>
        </Table.Cell>
         <Table.Cell style={{ whiteSpace: "nowrap"}}>
                <div>
                    {props.list.log_id || "N/A"}
                </div>
        </Table.Cell>
     

    </Table.Row>
)};

DatatableRow.propTypes = {
    list: PropTypes.object.isRequired,
};